import CheckBoxIcon from '@material-ui/icons/CheckBox';
import LifeCycle from '../application-core/Lifecycle';
import BrightnessFourIcon from '@material-ui/icons/Brightness4';
import AssignmentIcon from '@material-ui/icons/Assignment';
import GetAppIcon from '@material-ui/icons/GetApp';
import HistoryIcon from '@material-ui/icons/History';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import { Redirect } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../application-core/constants';
import ComponentBody from '../core/ComponentBody';
import ComponentDetail from '../core/ComponentDetail';
import HistoryViewer from '../core/HistoryViewer';
import HierarchyIcon from '../core/icons/Hierarchy';
import InAppBar from '../core/InAppBar';
import TripleViewer from '../core/TripleViewer';
import { getGraphFromProject } from '../core/utils/utils';
import DatasetQuality from './DatasetQuality';
import withGS from '../core/withGShoc';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import DatasetStatistics from './DatasetStatistics';
import DatasetExport from './DatasetExport';
import TemplateValidation from '../application-core/TemplateValidation';
import Associations from '../core/Associations';
import FindOntologyRelatedDataDualModePassthroughDialog from './FindOntologyRelatedDataDualModePassthroughDialog';

class DatasetData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      toIri: null
    };
  }

  changeView = (index) => this.setState({ view: index });

  toggleDetail = () => this.props.toggleDetail(1);

  onDisable = (item, disable = true) => {
    const disabledFeatures = this.props.data.disabledFeatures;
    const name = "quality-" + item;
    if (disable && disabledFeatures && disabledFeatures.includes(name)) return;
    // Hmm, where is it!
    if (!disable && disabledFeatures && !disabledFeatures.includes(name)) return;
    if (disable) {
      this.props.onAdd('disabledFeatures', name);
    }
    else {
      this.props.onDelete('disabledFeatures', name);
    }
  };

  render() {

    const { id, data, projectIRI, entitlements } = this.props;
    const { view, toIri } = this.state;
    const graph = getGraphFromProject(projectIRI);

    if (toIri) {
      return <Redirect to={APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/detail#project=' + projectIRI} />;
    }

    const appBar = <InAppBar
      tabValue={view}
      onChangeTab={this.changeView}
      tabItems={[
        {
          icon: HierarchyIcon,
          label: "Detail"
        },
        {
          icon: LinearScaleIcon,
          label: "Triples"
        },
        {
          icon: HistoryIcon,
          label: "History"
        },
        {
          icon: InsertChartIcon,
          label: "Statistics"
        },
        {
          icon: AssignmentIcon,
          label: "Quality"
        },
        {
          icon: CheckBoxIcon,
          label: "Validation"
        },
        {
          icon: GetAppIcon,
          label: "Export"
        },
        {
          icon: BrightnessFourIcon,
          label: "Lifecycle"
        }
      ]} />;

    const maxWidth = [800, null, null, 800, null, null, null, null][view];
    const datasetLink = APPLICATION_PATHS.DATA_MANAGER + '/project/dataset#project=' + projectIRI + "&dataset=" + id;

    return (
      <ProjectConsumer>
        {({ defaultLang, ontologyProjectAssociation, hasComponent, largeDataSettings }) => (
          <ComponentBody maxWidth={maxWidth} title={data.title} id={data.id} onToggleView={this.toggleDetail} appBar={appBar}>
            {view === 0 && <ComponentDetail
              id={id}
              findResourceDialog={FindOntologyRelatedDataDualModePassthroughDialog}
              graph={graph}
              batchupdateName="batchupdateDataProject"
              resourceTypeTitle="Resources"
              entitlements={entitlements}
              linkedProjectTypes={[
                "https://grafsync.graphifi.com/schema/gs/TaxonomyProject",
                "https://grafsync.graphifi.com/schema/gs/DataProject"
              ]}
              baseInferredClass="https://grafsync.graphifi.com/schema/gs/Dataset"
              associatedProject={data.associatedProject ?
                Array.isArray(data.associatedProject) ?
                  data.associatedProject
                  :
                  [data.associatedProject]
                :
                []
              }
              entitlement={ENTITLEMENTS.EDIT_DATASET}
              iriOptions={[]}
              includeNotes={true}
              includeAdditionalMetadata={true}
              includeAnnotate={true}
              includeLinkedResources={true}
              includeLinkedData={true}
              includeWorkflow={true}
              includeTemplates={true}
              includeClasses={true}
              projectType="DataProject"
              onToggleView={this.toggleDetail}
              includeSlashHash={true} />}
            {view === 1 && <TripleViewer
              id={id}
              useWorkflow={data.activateWorkflow === true}
              requiredEntitlement={ENTITLEMENTS.EDIT_DATASET}
              graph={graph}
              displayTitle={false} />}
            {view === 2 && <HistoryViewer
              options={[
                {
                  label: "Dataset Only",
                },
                {
                  label: "All Resources In Dataset",
                  resource: true,
                  path: [
                    "https://grafsync.graphifi.com/schema/gs/inDataset"
                  ]
                }
              ]}
              id={id}
              context={data.id}
              onToggleView={this.toggleDetail}
              graph={graph}
              displayTitle={false} />}
            {view === 3 && <DatasetStatistics
              workflow={data.activateWorkflow === true}
              id={id}
              graph={graph} />}
            {view === 4 && <DatasetQuality
              id={id}
              data={data}
              link={datasetLink}
              graph={graph}
              entitlement={ENTITLEMENTS.EDIT_DATASET}
              onDisable={this.onDisable}
              defaultLang={defaultLang}
              onToggleView={this.toggleDetail}
              ontologyProjectAssociation={ontologyProjectAssociation} />}
            {view === 5 && <Associations
              id={projectIRI}
              data={data}
              graph={graph}
              component={TemplateValidation}
              associatedProject={data.associatedProject ?
                Array.isArray(data.associatedProject) ?
                  data.associatedProject
                  :
                  [data.associatedProject]
                :
                []
              }
              resourceIn="https://grafsync.graphifi.com/schema/gs/inDataset"
              resourceTypes={[
                "https://grafsync.graphifi.com/schema/gs/Resource"
              ]}
              ontologyProjectAssociation={ontologyProjectAssociation}
              defaultLang={defaultLang}
              projectIRI={projectIRI}
              onToggleView={this.toggleDetail} />}
            {view === 6 && <DatasetExport
              id={id}
              graph={graph}
              annotations={data.activateAnnotate === true}
              defaultLang={defaultLang}
              entitlements={entitlements}
              ontologyProjectAssociation={ontologyProjectAssociation} />}
            {view === 7 && <LifeCycle
              id={id}
              graph={graph}
              defaultLang={defaultLang}
              entitlements={entitlements}
              largeDataSettings={largeDataSettings}
              skosXL={false}
              projectType="DataProject"
              inProp={["https://grafsync.graphifi.com/schema/gs/inDataset"]}
              labelType={["http://www.w3.org/2000/01/rdf-schema#label"]}
              sortProp="label"
              rto={[
                {

                  "value": "https://grafsync.graphifi.com/schema/gs/Resource",
                  "label": "Resource"
                }
              ]}
              useWorkflow={data.activateWorkflow === true}
              onToggleView={this.toggleDetail}
              components={hasComponent}
              projectIRI={projectIRI}
              componentIRI={id} />}
          </ComponentBody>
        )}
      </ProjectConsumer>
    );
  }

}

DatasetData.propTypes = {
  id: PropTypes.string.isRequired,
  entitlements: PropTypes.array,
  data: PropTypes.object.isRequired,
  projectIRI: PropTypes.string.isRequired,
  toggleDetail: PropTypes.func.isRequired
};

export default withGS(DatasetData);